import posthog from "@/lib/posthog";
import { ContrastModes } from "@/types/settings";

/**
 * Capture a color-theme change. No-ops when the operator re-selects the current theme.
 */
export function captureColorThemeChanged({
	newTheme,
	previousTheme,
}: {
	newTheme: ContrastModes;
	previousTheme: ContrastModes;
}) {
	if (newTheme === previousTheme) return;

	posthog.capture("color_theme_changed", {
		new_theme: newTheme,
		previous_theme: previousTheme,
	});
}
